export const WALLET_KEY = 'token';